import axios from 'axios'
const baseUrl = 'https://sydney-backend.vercel.app/api/v1/sites'


const getAll = () => {
    const request = axios.get(baseUrl)
    return request.then(response => response.data)
}

const getOne = (id) => {
    const request = axios.get(`${baseUrl}/${id}`)
    return request.then(response => response.data)
}

const getPopular = () => {
    const request = axios.get(`${baseUrl}/popular`)
    return request.then(response => response.data)
}


export default { getAll, getOne,getPopular}
